import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { DashboardPage } from './DashboardPage';

export function HomeRedirect() {
  const { user } = useAuth();
  if (user?.role === 'developer') return <Navigate to="/developer" replace />;
  return <DashboardPage />;
}
